// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {colorbrewer} from './3rd/custom_colorbrewer.js';
import _ from 'lodash';

import Escala from './Escala.jsx';

import {MT_ESC_GOOD, MT_ESC_BAD} from './consts.js';

import './css/PreviewCfgEscala.css';


type T_PreviewCfgEscala = {
  num_colors : number,
  name_escala: string,
  inv_escala : boolean,
  style?     : Object,
  header?    : string,
  father?    : Escala
};



export default class PreviewCfgEscala extends Component<T_PreviewCfgEscala> {
  componentWillUnmount() {
    if (this.props.father != null) {
      this.props.father.escala_mt = null;
    }
  }
  
  
  
  get_inner_html(): string {
    const el = ReactDOM.findDOMNode(this);
    
    if (el != null && el instanceof HTMLElement) {
      return el.innerHTML;
    }
    else {
      return '';
    }
  }
  
  
  
  render() {
    let colors = colorbrewer[this.props.name_escala][this.props.num_colors];
    
    if (! colors) {
      console.log(`no colors for ${this.props.name_escala} ${this.props.num_colors}`);
      
      return null;
    }
    
    if (! this.props.inv_escala) {                // <---- ! esta ok
      colors = _.reverse(_.cloneDeep(colors));
    }
    
    return (
      <div className='PreviewCfgEscala' style={this.props.style}>
        {colors.map((color: string, num) => {
          return (
            <div className='prevEscRow' key={num}>
              <div className='prevEscColor' key={color.slice(1)} style={{backgroundColor: color}} />
              
              <div className='prevEscLabel'>
                {num === 0 ? MT_ESC_GOOD : (num === colors.length - 1 && MT_ESC_BAD)}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PreviewCfgEscala.jsx